export const APIUrlToken = () => {
    return process.env.REACT_APP_TOKEN_API_URL
}
export const APIUrl = () => {
    return process.env.REACT_APP_DATA_API_URL
}
export const SetlocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};
export const getIsAdmin = () => {
    return localStorage.getItem("isAdmin");
};

export const getIsUser = () => {
    return JSON.parse(localStorage.getItem("nilUser"));
};

export const getUserRole = () => {
    return JSON.parse(localStorage.getItem("user_role"));
};
